export var HSSiteLogo = {
  small: '/images/Logo_Homestudios_small.png',
  large: '/images/Logo_Homestudios.png'
};